// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: shared/api/common/ENUM_SmartSearchRemortgageType.proto

export enum ENUM_SmartSearchRemortgageType {
  SMART_SEARCH_REMORTGAGE_TYPE_UNSPECIFIED = 'SMART_SEARCH_REMORTGAGE_TYPE_UNSPECIFIED',
  SMART_SEARCH_REMORTGAGE_TYPE_BORROW_MORE = 'SMART_SEARCH_REMORTGAGE_TYPE_BORROW_MORE',
  SMART_SEARCH_REMORTGAGE_TYPE_PAY_FASTER = 'SMART_SEARCH_REMORTGAGE_TYPE_PAY_FASTER',
  SMART_SEARCH_REMORTGAGE_TYPE_LIKE_FOR_LIKE = 'SMART_SEARCH_REMORTGAGE_TYPE_LIKE_FOR_LIKE',
  UNRECOGNIZED = 'UNRECOGNIZED',
}
